import { useState, useEffect, useRef, useCallback } from "react";
import { useAuthContext } from "./hooks/useAuthContext";
import Dropdown from "./Dropdown";
import { checkResponse } from "./utils";
import { useLogout } from "./hooks/useLogout";
import { Button, Table, Spinner, Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";


export default function Stadstreck(props) {
  const [stadstreck, setStadstreck] = useState(props.stadstreck || []);
  const [nextCleaners, setNextCleaners] = useState([0, 1]);
  // const [loading, setLoading] = useState(true);

  const [showGiveModal, setShowGiveModal] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [obligatoryClean, setObligatoryClean] = useState([false, false]);
  const [showRemoveSinglePersonModal, setShowRemoveSinglePersonModal] = useState(false);
  const [updatedRowId, setUpdatedRowId] = useState(null);

  const [comment, setComment] = useState('');

  const { user } = useAuthContext();
  const { logout } = useLogout();

  const handleCloseGiveModal = () => {
    // reset comment when closing modal
    setComment('');
    setShowGiveModal(false);
  }
  const handleShowGiveModal = () => setShowGiveModal(true);

  const handleCloseRemoveModal = () => setShowRemoveModal(false);
  const handleCloseRemoveSinglePersonModal = () => setShowRemoveSinglePersonModal(false);
  const handleShowRemoveModal = () => setShowRemoveModal(true);
  const handleShowRemoveSinglePersonModal = () => setShowRemoveSinglePersonModal(true);

  const isFetchedRef = useRef(false);

  const fetchCleaners = useCallback(async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/streck/stadstreck/fetchCleaners/`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!await checkResponse(response, logout)) return false;

    const data = await response.json();
    const { firstCleaner, secondCleaner, stadstreck, obligatoryCleanFirst, obligatoryCleanSecond } = data;

    setNextCleaners([firstCleaner, secondCleaner]);
    setObligatoryClean([obligatoryCleanFirst, obligatoryCleanSecond]);
    setStadstreck(stadstreck);
  }, [user.token, logout]);

  useEffect(() => {
    async function fetchData() {
      await fetchCleaners();
    }

    if (!isFetchedRef.current) {
      isFetchedRef.current = true;

      if (user) {
        fetchData().catch(console.error);
      }
    }
  }, [user, logout, fetchCleaners]);


  useEffect(() => {
    // Initialize the stadstreck state with the value of props.stadstreck when the component mounts
    setStadstreck(props.stadstreck);
  }, [props.stadstreck]);

  async function removeCleaners(cleanerOne, cleanerOneStadstreck, cleanerTwo, cleanerTwoStadstreck) {
    let firstPerson = {
      position_number: cleanerOne,
      value: cleanerOneStadstreck
    };

    let secondPerson = {
      position_number: cleanerTwo,
      value: cleanerTwoStadstreck
    };

    const body = JSON.stringify([firstPerson, secondPerson]);

    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/streck/update/stadstreck/removeStadstreck`, {
      method: "POST",
      body: body,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

    if (!await checkResponse(response, logout)) return false;

    const stadstreck = await response.json();

    setStadstreck(stadstreck);
  }

  // remove the current cleaners
  async function removeCurrentCleaners() {
    const firstCleaner = nextCleaners[0];
    const secondCleaner = nextCleaners[1];

    const firstCleanerStadstreck = stadstreck[firstCleaner].stadstreck;
    const secondCleanerStadstreck = stadstreck[secondCleaner].stadstreck;

    const authorized = await removeCleaners(firstCleaner, firstCleanerStadstreck, secondCleaner, secondCleanerStadstreck);

    return authorized;
  }



  // function to give stadstreck to selected persion
  async function giveStadstreck() {
    const currDate = new Date().toISOString();

    // you can max get -1 stadstreck
    if (props.count === -1 && stadstreck[props.positionNumber].stadstreck < 0) {
      window.alert(`${stadstreck[props.positionNumber].position} har redan -1 städstreck.`);

      return;
    }

    const editedPerson = {
      position_number: props.positionNumber,
      value: props.count,
      date: currDate,
      update_total: props.count > 0 ? true : false,
      comment: comment,
    };

    const body = [editedPerson];
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/streck/update/stadstreck`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

    if (!await checkResponse(response, logout)) return false;

    setUpdatedRowId(props.positionNumber);
  }

  async function removeSingleCleaner(positionNumber) {
    let person = {
      position_number: positionNumber,
      value: stadstreck[positionNumber].stadstreck
    };

    const body = JSON.stringify([person]);

    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/streck/update/stadstreck/removeStadstreck`, {
      method: "POST",
      body: body,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

    if (!await checkResponse(response, logout)) return false;
  }

  async function onClickGive(e) {
    e.preventDefault();
    await giveStadstreck();
    await fetchCleaners();
    // reset comment when closing modal
    setShowGiveModal(false);
    setComment('');
  }



  async function onClickRemove(e) {
    e.preventDefault();

    try {
      const removeCurrentCleanersResponse = await removeCurrentCleaners();
      if (removeCurrentCleanersResponse === false) return;

      await fetchCleaners();

    } catch (error) {
      toast.error(error);
    }
    setShowRemoveModal(false);
  }

  async function onClickRemoveSinglePerson(e) {
    e.preventDefault();

    try {

      // Remove clean for single persoon
      if (stadstreck[props.positionNumber].stadstreck === 0 && stadstreck[props.positionNumber].has_cleaned_obligatory) {
        setShowRemoveSinglePersonModal(false);
        toast.error(`${stadstreck[props.positionNumber].position} har 0 städstreck och har redan städat sitt poststäd så det går inte att avverka ett städstreck.`);
        return;
      }

      const removeSingleCleanResponse = await removeSingleCleaner(props.positionNumber);
      if (removeSingleCleanResponse === false) return;

      await fetchCleaners();

      // setStadstreck(stadstreck);
    } catch (error) {
      toast.error(error);
    }
    setShowRemoveSinglePersonModal(false);
  }

  const renderNumberOfObligatoryCleans = (positionNumber) => {
    const numberOfObligatoryCleans = stadstreck[positionNumber]?.number_of_obligatory_cleans;
    return numberOfObligatoryCleans > 0 ? `(Poststäd #${numberOfObligatoryCleans + 1})` : '(Poststäd)';
  }

  const stadstreckRows = Object.entries(stadstreck).map(([_, value]) => (
    <tr key={value._id} className={updatedRowId === value.position_number ? 'flash' : ''}>
      <td>{value.position}</td>
      <td>{JSON.stringify(value.stadstreck)}</td>
      <td>{JSON.stringify(value.total_stadstreck)}</td>
    </tr>
  ));

  const stadstreckPosition = stadstreck[props.positionNumber]?.position;
  const firstCleaner = stadstreck[nextCleaners[0]]?.position;
  const secondCleaner = stadstreck[nextCleaners[1]]?.position;

  const keydownHandlerGiveModal = async (e) => {
    switch (e.key) {
      case 'Enter':
        e.preventDefault();
        await onClickGive(e);
        break;
      default:
    }
  };

  const keydownHandlerRemoveModal = async (e) => {
    switch (e.key) {
      case 'Enter':
        e.preventDefault();
        await onClickRemove(e);
        break;
      default:
    }
  };

  // TODO: perhaps unfocus button after press, to prevent several being given.
  useEffect(() => {
    if (showGiveModal) {
      document.addEventListener('keydown', keydownHandlerGiveModal);
    }

    if (showRemoveModal) {
      document.addEventListener('keydown', keydownHandlerRemoveModal);
    }

    return () => {
      document.removeEventListener('keydown', keydownHandlerGiveModal);
      document.removeEventListener('keydown', keydownHandlerRemoveModal);
    };
  },);

  return (
    <div className="container">
      <div className="stadstreck-div">
        <h2>Städstreck</h2>
        <div className="next-clean-container">
          <h4>Nästa städ:</h4>
          {stadstreck.length > 0 && nextCleaners.map((cleaner_position_number, index) => (
            <h4 key={stadstreck[cleaner_position_number]?._id}>
              <div>
                <p
                  className={`obligatory-clean ${props.theme === 'dark' ? 'dark' : ''}`}
                  style={{ visibility: obligatoryClean[index] ? 'visible' : 'hidden' }}
                >
                  {renderNumberOfObligatoryCleans(cleaner_position_number)}
                </p>
                <span>
                  {stadstreck[cleaner_position_number]?.position}
                </span>
              </div>
            </h4>
          ))}
        </div>
      </div>
      {
        props.loading || stadstreck.length === 0 ? (<div className="div-spinner">
          <Spinner animation="border" role="status" />
        </div>) :
          (<Table striped bordered hover responsive="sm" variant={props.theme}>
            <thead>
              <tr className="same-col-widths">
                <th>Post</th>
                <th>Antal</th>
                <th>Totalt</th>
              </tr>
            </thead>
            <tbody>
              {stadstreckRows}
            </tbody>
          </Table>)
      }

      {user.role === "admin" && (
        <>
          <Modal
            show={showGiveModal}
            onHide={handleCloseGiveModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>Ge städstreck</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Vill du verkligen ge {stadstreckPosition} {props.count} städstreck?</p>
              <Form>
                <Form.Group controlId="formInput">
                  <Form.Label>Kommentar:</Form.Label>
                  <Form.Control
                    type="text"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)} />
                  <Form.Text style={{ color: props.theme === 'dark' ? 'lightgray' : 'gray' }}>
                    Lägg till en kommentar om anledningen till städstrecket/städstrecken (om du vill).
                  </Form.Text>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseGiveModal}>Stäng</Button>
              <Button variant="primary" onClick={onClickGive}>Ge {props.count} städstreck!</Button>
            </Modal.Footer>

          </Modal>


          <Modal
            show={showRemoveModal}
            onHide={handleCloseRemoveModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>Avverka städstreck</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Vill du verkligen avverka ett städstreck för {firstCleaner} och {secondCleaner}?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseRemoveModal}>Stäng</Button>
              <Button variant="primary" onClick={onClickRemove}>Avverka städstreck!</Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showRemoveSinglePersonModal}
            onHide={handleCloseRemoveSinglePersonModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>Avverka städs för {stadstreckPosition}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Vill du verkligen avverka ett städ för {stadstreckPosition}?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseRemoveSinglePersonModal}>Stäng</Button>
              <Button variant="primary" onClick={onClickRemoveSinglePerson}>Avverka ett städ!</Button>
            </Modal.Footer>
          </Modal>

          <div className="dropdown-button-div">
            <Dropdown id="stadstreckDropdown"></Dropdown>
            <div className="button-div">
              <Button variant={props.theme === 'dark' ? 'secondary' : 'primary '} disabled={props.loading} className="mb-1 py-1" onClick={handleShowGiveModal}>Ge Städstreck!</Button>
              <Button variant={props.theme === 'dark' ? 'secondary' : 'primary '} disabled={props.loading} className="mb-1 py-1" onClick={handleShowRemoveSinglePersonModal}>Avverka Städ för {stadstreckPosition}!</Button>
            </div>
            <Button variant={props.theme === 'dark' ? 'secondary' : 'primary '} disabled={props.loading} className="dropdown-button-div" onClick={handleShowRemoveModal}>Avverka Städ för {firstCleaner} & {secondCleaner}!</Button>
          </div>
        </>
      )}
    </div>
  );
}
